import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { QuoteReceipt } from "../../../../../components/QuoteReceipt";
import { CheckoutReceiptFragment } from "./CheckoutReceipt.fragment";
export const CheckoutReceipt = t0 => {
  const $ = _c(6);
  const {
    initialPrices,
    quote: quoteKey,
    hidePricing
  } = t0;
  let t1;
  if ($[0] !== quoteKey) {
    t1 = readFragment(CheckoutReceiptFragment, quoteKey);
    $[0] = quoteKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const quote = t1;
  let t2;
  if ($[2] !== hidePricing || $[3] !== initialPrices || $[4] !== quote) {
    t2 = <QuoteReceipt hidePricing={hidePricing} initialPrices={initialPrices} quote={quote} />;
    $[2] = hidePricing;
    $[3] = initialPrices;
    $[4] = quote;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};